import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetSessions, GetSessionsResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetSessionsResponse, GetSessionsResponse>) => response?.data?.sessions;

const getError = (response?: SWRResponse<GetSessionsResponse, GetSessionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetSessionsResponse, GetSessionsResponse>) => ({
    sessions: response?.data?.sessions
});

export const useSessions = (configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        
        return () => {
            return new GetSessions({});
        };
    }, [])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useSessions;